module.exports = __webpack_public_path__ + "img/beian.72d5da96.png";